const contactwords ={
    'msg1':{'es':'Conectemos','en':'Let’s connect'},
    'msg2':{'es':'Si tienes alguna pregunta o deseas saber más sobre mis servicios, no dudes en contactarme por whatsapp o enviando un mensaje.','en':'If you have any questions or would like to know more about my services, feel free to contact me via WhatsApp or by sending a message.'}
}

export default contactwords;